import { useAutoGameRedirect } from '@features/game/hooks/useAutoGameRedirect';

// Компонент вместо прямого вызова хука: там, где редирект на партию не нужен
// (страница телефона, комната судьи), его просто не монтируют — тогда не
// открываются ни сокет пользователя, ни запрос ближайших туров
export function AutoGameRedirect() {
  useAutoGameRedirect();
  return null;
}
